module.exports = __webpack_public_path__ + "img/folder_icon_gray.195725ea.svg";